<template>
  <div v-if="sitemap && sitemap.sections" id="sitemap">
    <h1>Teach Starter {{ $i18n.locale.toUpperCase() }} Sitemap</h1>
    <section v-for="(section, index) in sitemap.sections" :key="index">
      <!-- Section title -->
      <h2 v-if="section.title">
        <nuxt-link v-if="section.title.link" :to="section.title.link" class="heading-link">
          {{ section.title.label }}
        </nuxt-link>
        <template v-else>
          {{ section.title.label }}
        </template>
      </h2>

      <!-- Subsections -->
      <div class="subsection">
        <div
          v-for="(subsection, subsectionIndex) in section.subsections"
          :key="subsectionIndex"
          class="links"
        >
          <!-- Subsection title -->
          <nuxt-link v-if="subsection.title.link" :to="subsection.title.link" class="heading-link">
            <h3>{{ subsection.title ? subsection.title.label : '&nbsp;' }}</h3>
          </nuxt-link>
          <template v-else>
            <h3>{{ subsection.title ? subsection.title.label : '&nbsp;' }}</h3>
          </template>

          <!-- Links -->
          <template v-for="link in subsection.links">
            <a v-if="link.link.includes('http')" :key="link.label" :href="link.link">
              {{ link.label }}
            </a>
            <nuxt-link v-else :key="link.label" no-prefetch :to="link.link">
              {{ link.label }}
            </nuxt-link>
          </template>
        </div>
      </div>
      <hr />
    </section>
    <section class="subsection">
      <nuxt-link to="/au/" class="heading-link"><h4>Teach Starter Australia</h4></nuxt-link>
      <nuxt-link to="/us/" class="heading-link"><h4>Teach Starter United States</h4></nuxt-link>
      <nuxt-link to="/gb/" class="heading-link"><h4>Teach Starter United Kingdom</h4></nuxt-link>
    </section>
  </div>
</template>
<script>
import sitemap from '~/data/sitemap.json';

export default {
  name: 'Sitemap',
  data() {
    return {
      sitemap:
        this.$i18n.locale && sitemap[this.$i18n.locale] ? sitemap[this.$i18n.locale] : sitemap.au,
      title: this.$i18n.locale.toUpperCase() + ' Sitemap',
    };
  },
  head() {
    return {
      title: this.title,
    };
  },
};
</script>
<style scoped>
#sitemap {
  width: 100%;
  max-width: 62rem;
  margin: 2rem auto;
  padding: 1rem;
}
.subsection {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1rem;
}
.heading-link {
  color: unset;
}
.links {
  min-width: 30%;
  display: flex;
  flex-direction: column;
}
@media screen and (max-width: 640px) {
  .subsection {
    grid-template-columns: 1fr;
  }
}
</style>
